import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";
import Img3 from "public/iaas/containerizedHosting.0e1aa36b.svg";
import secImg from "public/home/cyberSec.svg";
import FinancialServicesImg from "public/iaas/finnacialServices.svg";
import StreamingImg from "public/iaas/streaming.svg";

export const USECASES_CONSTANTS = {
  title: "Real-World Use Cases: Why Businesses Choose OneMind Services Bare Metal",
  desc: "When performance and reliability are non-negotiable, businesses turn to Bare Metal solutions. Here’s how OneMind Services is revolutionizing industries with next-gen, high-performance infrastructure: ",
  list: [
    {
      image: Img1,
      title: "High-Performance Computing (HPC) & AI Workloads",
      content:
        "Speed is everything when training machine learning models or processing vast datasets. OneMind Services’ Bare Metal servers eliminate virtualization bottlenecks, delivering the ultra-low latency and high throughput that AI and HPC applications demand.",
    },
    {
      image: Img2,
      title: "Big Data & Analytics",
      content:
        "Data-driven decisions require massive computing power. With OneMind Services’ high-speed, dedicated Bare Metal servers, businesses can process and analyze enormous datasets faster than ever using managed performance that drives innovation and efficiency.",
    },
    {
      image: StreamingImg,
      title: "Gaming & Streaming Platforms",
      content:
        "Data-driven decisions require massive computing power. With OneMind Services’ high-speed, dedicated Bare Metal servers, businesses can process and analyze enormous datasets faster than ever using managed performance that drives innovation and efficiency.",
    },
    {
      image: FinancialServicesImg,
      title: "Financial Services & Trading",
      content:
        "When milliseconds equal millions, infrastructure matters. OneMind Services’ Bare Metal solutions provide the low-latency, high-security environment that financial institutions need for algorithmic trading and real-time transaction processing.",
    },
    {
      image: Img3,
      title: "SaaS & Cloud-Native Applications",
      content:
        "Scale without constraints. OneMind Services’ Bare Metal solutions deliver the performance of dedicated hardware with the flexibility of cloud-native orchestration, ensuring seamless scalability for SaaS providers and cloud-native developers.",
    },
    {
      image: secImg,
      title: "Enterprise-Grade Security & Compliance",
      content:
        "Businesses handling sensitive data—healthcare, legal, or government sectors—trust OneMind Services for its secure, compliant, and high-performance Bare Metal infrastructure that meets the highest industry standards.",
    },
  ],
};
